module.exports = __webpack_public_path__ + "img/map-xs.58285646.jpg";